import styled from 'styled-components';
import { TextPairing } from '@components/TextPairing';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Box } from '@components/Box';
import { CTALink } from '@components/CTALink';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { CloudImage, defaultBase64Placeholder } from '@components/CloudImage';

const desktopContainer = '1440px';
const desktopWrapper = '1400px';

const mobileContainer = '1000px';
const mobileWrapper = '960px';

export const SectionWrapper = styled(Box)`
  position: relative;
  height: ${desktopContainer};
  ${themeMediaQuery('below_sm')} {
    height: ${mobileContainer};
  }
`;

export const MainTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 410px;
  }
  .text-pairing-body {
    max-width: 550px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 240px;
    }
    .text-pairing-body {
      max-width: 250px;
    }
  }
`;

export const OddTextPairingWrapper = styled(Box)`
  opacity: 0;
  display: none;
  z-index: -1;
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    top: 25px;
  }
  ${themeMediaQuery('sm')} {
    margin-top: ${themeSpace(15)};
  }
  ${themeMediaQuery('md')} {
    margin-top: 0;
  }
`;

export const MultipleEventsTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 410px;
  }
  .text-pairing-body {
    max-width: 382px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 230px;
    }
    .text-pairing-body {
      max-width: 320px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 500px;
    }
  }
`;

export const LinkWrapper = styled(CTALink)<{
  color: string;
}>`
  color: ${(props) => props.color};
`;

export const SectionBoxWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;

export const SectionBox = styled(Box)`
  position: relative;
  height: 100%;
  width: 100vw;
`;

export const InitialImageWrapper = styled(Box)<{ isScrolledIntoView: boolean }>`
  height: ${desktopWrapper};
  width: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url(${({ isScrolledIntoView }) =>
      isScrolledIntoView
        ? cloudAssetUrl('wedding-invitations/multiple-private-events/multi-event-rsvp-bgmulti-event-rsvp-bg1.jpg')
        : defaultBase64Placeholder});
  background-repeat: no-repeat;
  background-size: cover;
  ${themeMediaQuery('below_sm')} {
    height: ${mobileWrapper};
  }
`;

export const MultipleBackgroundWrapper = styled(Box)`
  position: relative;
  height: ${desktopWrapper};
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    height: ${mobileWrapper};
  }
`;
export const MultipleBackgroundContent = styled(Box)<{ size: number; left: number; top: number; respDimension: number }>`
  position: absolute;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  left: ${(props) => props.left}%;
  top: ${(props) => props.top}%;
  border-radius: 50%;
  overflow: hidden;
  ${themeMediaQuery('below_sm')} {
    height: ${(props) => props.respDimension}px;
    width: ${(props) => props.respDimension}px;
    opacity: 0.2;
  }
`;

export const LottieWrapper = styled(Box)`
  width: 100%;
  height: 575px;
  margin: -${themeSpace(9)} auto ${themeSpace(0)};
  ${themeMediaQuery('below_sm')} {
    height: auto;
    margin-top: ${themeSpace(9)};
  }
`;

export const LottieContainer = styled.div`
  width: 700px;
  height: 350px;
  margin: ${themeSpace(11)} auto 0 auto;
  ${themeMediaQuery('below_sm')} {
    margin-top: ${themeSpace(0)};
    width: 100%;
    height: auto;
    transform: scale(1.6);
  }
`;

export const LearnMoreWrapper = styled(Box)`
  width: 125px;
  margin: ${themeSpace(7)} auto;
`;

export const MultiImageContainer = styled(CloudImage)`
  object-fit: cover;
`;
